import { Flex, Text, Box } from '@chakra-ui/react';
import { Tcard } from 'pages/Home/types';
import { FC } from 'react';
import icons, { TIcon } from 'shared/icons';
import ALinkableCard from 'components/atoms/ALinkableCard';

const MPageStatisticsReviewSection: FC<{ icon: TIcon; title: string; cards: Tcard[] }> = ({ icon, title, cards }) => {
    const SectionIcon = icons[icon] || icons.warning;

    const renderCards = () => {
        return (
            <Flex mt={8} flexWrap="wrap">
                {cards.map((card) => (
                    <ALinkableCard
                        key={card.title}
                        title={card.title}
                        value={card.value}
                        path={card.path}
                        mr={6}
                        mb={6}
                        {...(card.link ? { link: card.link } : {})}
                    />
                ))}
            </Flex>
        );
    };

    return (
        <Box mx="32px" pt="10px" pb={3}>
            <Flex
                pb="10px"
                borderBottom="1px solid"
                borderColor="gray.100"
                alignItems="center"
                fontSize="md"
                color="gray.500"
            >
                <SectionIcon width="18px" height="auto" />
                <Text fontWeight="600" ml={2} as="h2">
                    {title}
                </Text>
            </Flex>
            {renderCards()}
        </Box>
    );
};

export default MPageStatisticsReviewSection;
